export default 'M24 4.5H0v-3h24zm0 6H6v-3h18zm0 6H0v-3h24zm0 6H6v-3h18z';